/**
 * Centralized API configuration for the tenant portal.
 *
 * Uses VITE_API_URL only here — components and services import from this module.
 */

const getApiBaseUrl = (): string => {
  const viteApiUrl = import.meta.env.VITE_API_URL;

  if (viteApiUrl) {
    return viteApiUrl;
  }

  if (import.meta.env.DEV) {
    return '/api';
  }

  return '/api';
};

export const API_BASE_URL = getApiBaseUrl();

/** Scheme + host for server-relative paths (strips trailing `/api`). Empty when using relative `/api`. */
export const getApiOrigin = (): string => API_BASE_URL.replace(/\/api\/?$/, '');

export const buildApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

const PRODUCTION_PORTAL_ORIGIN = 'https://app.amberpeak.ca';

/** Prospect login link for the site the person is actually using. */
export function getProspectPortalLoginUrl(): string {
  const origin = import.meta.env.PROD
    ? PRODUCTION_PORTAL_ORIGIN
    : window.location.origin.replace(/\/$/, '');
  return `${origin}/?intent=prospect`;
}
